import Api from '../Api';

interface IRequestObject {
  specification: string;
  orderId: string;
  lineItemId: string;
  customLineItemId: string;
  attachments?: any[];
}

interface IOrderGuidanceRequest {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  preferredCallTime?: string;
  description: string;
  attachments?: string[];
}

interface IResponseObject {
  success?: boolean;
  data?: {
    success: boolean;
  };
  reason?: string;
}

class Services extends Api {
  async createZendeskTicketDesignFile(reqObj: IRequestObject):Promise<IResponseObject | Error> {
    if (!reqObj) {
      return Promise.resolve({ reason: 'No request payload' });
    }

    try {
      return await this.httpClient.post('/services/file-design', reqObj);
    } catch (error: unknown) {
      if (error instanceof Error) {
        return Promise.resolve(error);
      }

      return Promise.resolve({ reason: 'API call failed' });
    }
  }

  async createZendeskTicketChangeFile(reqObj: IRequestObject):Promise<IResponseObject | Error> {
    if (!reqObj) {
      return Promise.resolve({ reason: 'No request payload' });
    }

    try {
      return await this.httpClient.post('/services/file-change', reqObj);
    } catch (error: unknown) {
      if (error instanceof Error) {
        return Promise.resolve(error);
      }

      return Promise.resolve({ reason: 'API call failed' });
    }
  }

  async createZendeskTicketOrderGuidance(reqObj: IOrderGuidanceRequest):Promise<IResponseObject | Error> {
    if (!reqObj) {
      return Promise.resolve({ reason: 'No request payload' });
    }

    try {
      return await this.httpClient.post('/services/order-guidance', reqObj);
    } catch (error: unknown) {
      if (error instanceof Error) {
        return Promise.resolve(error);
      }

      return Promise.resolve({ reason: 'API call failed' });
    }
  }
}

export default Services;
export type { IOrderGuidanceRequest };
